import { CREDENTIAL_ROUTE_NAMES } from "@/router/credential.routes/credential.routes.names";
import type { IScopeModel, IUIAssetCreationMeta } from "./global.model";
import type {
  Scope,
  AccessKeyUpdateRequest,
  PasswordUpdateRequest,
  AccessKeyCreationSpec,
  DockerRegistryCreationSpec,
  PasswordCreationSpec,
  GenericSecretCreationSpec,
} from "@/swagger-models/assets-service-client";
import { AssetKind } from "@/swagger-models/assets-service-client";

export const credentialTextForUI: Record<string, string> = {
  accessKey: "Access key",
  password: "Username & password",
  dockerRegistry: "Docker registry",
  genericSecret: "Generic secret",
};

export type TCredentialKinds =
  | typeof AssetKind["AccessKey"]
  | typeof AssetKind["Password"]
  | typeof AssetKind["DockerRegistry"]
  | typeof AssetKind["GenericSecret"];
export type TCredentialUpdateRequests = AccessKeyUpdateRequest | PasswordUpdateRequest;

export type TCredentialCreationRoutes =
  | typeof CREDENTIAL_ROUTE_NAMES.CREDENTIAL_ACCESS_KEY_NEW
  | typeof CREDENTIAL_ROUTE_NAMES.CREDENTIAL_USERPASS_NEW
  | typeof CREDENTIAL_ROUTE_NAMES.CREDENTIAL_DOCKER_REGISTRY_NEW
  | typeof CREDENTIAL_ROUTE_NAMES.CREDENTIAL_GENERIC_SECRET_NEW;

export const CREDENTIAL_CREATION_ROUTES_TO_CREDENTIAL_KINDS: Record<TCredentialCreationRoutes, TCredentialKinds> = {
  [CREDENTIAL_ROUTE_NAMES.CREDENTIAL_ACCESS_KEY_NEW]: AssetKind.AccessKey,
  [CREDENTIAL_ROUTE_NAMES.CREDENTIAL_USERPASS_NEW]: AssetKind.Password,
  [CREDENTIAL_ROUTE_NAMES.CREDENTIAL_DOCKER_REGISTRY_NEW]: AssetKind.DockerRegistry,
  [CREDENTIAL_ROUTE_NAMES.CREDENTIAL_GENERIC_SECRET_NEW]: AssetKind.GenericSecret,
};

export interface IScopeCredentialsList extends Omit<IScopeModel, "scope" | "clusterId"> {
  scope?: Scope;
  clusterUuid?: string;
}
export interface IUIAccessKeyCreationRequest {
  meta: IUIAssetCreationMeta;
  spec: AccessKeyCreationSpec;
}
export interface IUIDockerRegistryCreationRequest {
  meta: IUIAssetCreationMeta;
  spec: DockerRegistryCreationSpec;
}
export interface IUIPasswordCreationRequest {
  meta: IUIAssetCreationMeta;
  spec: PasswordCreationSpec;
}

export interface IUIGeneralCredentialCreationRequest {
  meta: IUIAssetCreationMeta;
  spec: GenericSecretCreationSpec;
}

export interface INewGeneralSecret {
  key: string;
  value: string;
}
